import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CoreTranslateService, UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import { ApiService } from 'src/app/services/api/api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-modal-point-transfer',
  templateUrl: './modal-point-transfer.component.html',
  styleUrls: ['./modal-point-transfer.component.scss']
})
export class ModalPointTransferComponent implements OnInit {

  @ViewChild('pointTransferModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  receiver: any = {};
  myProfile: any = {};
  userId: any;
  isShow = false;
  pointTermsTransfer: any = [];
  myPoint :any;
  errorMsg: any = '';
  transferPointModel: any = {};

  constructor( private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private coreTranslate: CoreTranslateService) { }

  ngOnInit() {
    this.modalServ.onPointTransfer.subscribe(req => {
      this.getMyPoint();
      this.getPointTermsTransfer();
      this.receiver = req.receiver;
      console.log(this.receiver);
      this.myProfile = req.myProfile;
      this.userId = req.userId;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onPointTransferHide.subscribe(req => {
      this.hide();
    });
    
  }
  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }
  favorite(){
        var favoriteModel: any = {};
        favoriteModel.friendId = this.receiver.UserID ;
        this.api.crateFavoriteFriend(favoriteModel).subscribe(res => {
          console.log(res);
          if(res.Code == 200) {
            this.receiver.IsFavoriteFriend = !this.receiver.IsFavoriteFriend;
           
          } else {
            console.error(res);
          }
        }, err => {
          console.error(err);
        });
   
  }
  getMyPoint() {
    
    this.api.getMyPoint().subscribe((res: any) => {
      console.log(res);
       this.myPoint = res.Results;
       console.log(this.myPoint.CurrentPoint);
    }, (err: any) => {
     
      console.log(err);
    });
    // console.log(this.myProfile);
    
  }
  getPointTermsTransfer() {
    this.api.getPointTermsTransfery().subscribe(res => {
      if (res.Code == 200) {
        this.pointTermsTransfer = res.Results;
      } else {
        console.error(res);
      }
    }, err => {
      console.error(err);
    });
  }

  confirm() {
    if(!this.validation()) return;
    var terms = this.pointTermsTransfer.find(x => x.ID == this.transferPointModel.terms);
    if(Object.keys(terms).length === 0)return;
    console.log(terms);
    this.modalServ.onConfirm.emit({title: this.coreTranslate.getWord('POINT.TRANSFER_POINTS') , content: this.coreTranslate.getWord('POINT.YOU_WANT_TO_TRANSFER') + ' ' + terms.Point + ' ' + this.coreTranslate.getWord('POINT.GIVE_A_SCORE') + ' ' + this.receiver.FullName , callback: res=> {
      if(res.status == 'confirm') {
        this.TransferPoint(terms.Point);
        
      }
    }});
  }

  validation() {
    if (Object.keys(this.transferPointModel).length === 0) {
      this.errorMsg = this.coreTranslate.getWord('POINT.PLEASE_FILL_ALL_INFORMATION');
      return false;
    } else if(!this.transferPointModel.terms) {
      this.errorMsg = this.coreTranslate.getWord('POINT.SELECT_SCORE_FORMAT');
      return false;
    }  

    return true;
  }

  TransferPoint(point: any) {
    let body: any = {};
    body.receiver_Id =  this.receiver.UserID    ;
    body.point = point;
    body.remark = this.transferPointModel.remark;
     
    console.log(body);

    this.ngxLoading.start()
    this.api.TransferPoint(body).subscribe((res: any) => {
      const lang = this.coreTranslate.getLang() || 'th';
      const Message = lang == 'en' ? res.Message : res.MessageAlt;
      if(res.Code == 200){
        this.modalServ.onPointTransferred.emit({status: 'success', message: Message, point: point});
      } else {
        this.modalServ.onPointTransferred.emit({status: 'fail', message: Message, point: point});
      }
      this.hide();
      this.ngxLoading.stopAll();
    }, (err) => {
      this.modalServ.onPointTransferred.emit({status: 'fail', message: 'Internal Error.', point: point});
      console.log(err);
      this.ngxLoading.stopAll();
    });
  }
}
